module.exports = __webpack_public_path__ + "img/usage-4.30393ade.png";